const DELETE_STATUS = {
  CANCEL: 'cancel',
  DELETED: 'deleted',
  PENDING: 'pending',
  TRASH: 'trash',
  RESTORE: 'restore',
};

export default DELETE_STATUS;
